import React, { useState } from 'react';
import { MaterialReactTable, type MRT_ColumnDef } from 'material-react-table';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Box, CircularProgress, useTheme, Skeleton, styled } from "@mui/material";
import { useGetAllSafetyQuery } from "store/slices/apis/safetyPackageSlice";
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';

type Person = {
  //sno: string;
  safety_number: string;
  consultant_constractor: string;
  approved_status: string;
  status: string;
  createddate: string;
  date: string;
  labour_man_hours: string;
  manhours_since_last_lta_lti: string;
  near_miss_incident: string;
  ltas_ltis: string;
  fatalities: string;
};

const columns: MRT_ColumnDef<Person>[] = [
  // { accessorKey: 'sno', header: 'S No.' },
  { accessorKey: 'safety_number', header: 'Safety ID', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'consultant_constractor', header: 'Consultant/Contractor', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center', sx: { whiteSpace: 'nowrap' }, }, },
  // { accessorKey: 'approved_status', header: 'Workflow Status', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center', sx: { whiteSpace: 'nowrap' }, }, },
  { accessorKey: 'status', header: 'Status', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'createddate', header: 'Created Date', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'date', header: 'Date', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'labour_man_hours', header: 'Labour Man Hours', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'manhours_since_last_lta_lti', header: 'Manhours Since Last LTA LTI', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'near_miss_incident', header: 'Near Miss Incident', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'ltas_ltis', header: 'LTAs LTIs', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
  { accessorKey: 'fatalities', header: 'Fatalities', muiTableHeadCellProps: { align: 'center' }, muiTableBodyCellProps: { align: 'center' }, },
];

// Format helper
const formatDate = (dateString?: string) =>
  dateString ? dayjs(dateString).format('DD/MM/YY') : '';

// Flatten formatter (no children)
const formatScheduleData = (data: any[]): Person[] =>
  data.map((item) => ({
    // sno: item.sno,
    safety_number: item.safety_number,
    consultant_constractor: item.consultant_constractor,
    approved_status: item.approved_status,
    status: item.status,
    createddate: formatDate(item.createddate),
    date: formatDate(item.date),
    labour_man_hours: item.labour_man_hours,
    manhours_since_last_lta_lti: item.manhours_since_last_lta_lti,
    near_miss_incident: item.near_miss_incident,
    ltas_ltis: item.ltas_ltis,
    fatalities: item.fatalities,
  }));

export default function SafetyNCRList() {

  const newtheme = useTheme();
  const { projectId } = useParams();

  const { data, isLoading, error } = useGetAllSafetyQuery({
    projectId,
    sortBy: "createddate",
    sortOrder: "desc",
    approved_status: "Approved",
  });

  const dataval: Person[] = data?.data ? formatScheduleData(data?.data) : [];


  return (
    <Box sx={{
      width: "100%", border: "1px solid #D8D8D8", mt: "10px", borderRadius: "12px", overflow: "hidden",
    }}>
      <Box sx={{ backgroundColor: "#fff", p: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 500, color: `${newtheme?.customSettings?.themeColor}`, fontSize: "18px" }}>
          Safety NCR List
        </Typography>
        <Typography sx={{ mb: 1, color: "#666" }}>
          Total safety non-conformance that are documented for tracking and addressing all observed
          deviations from safety standard.
        </Typography>
      </Box>
      {isLoading ? (
        <Box display="flex" justifyContent="center" mt={4} pb={1}>
          <CircularProgress />
        </Box>
      ) : error ? (
        <Typography color="error">Failed to load data.</Typography>
      ) : (
        <MaterialReactTable
          columns={columns}
          data={dataval}
          // enableRowNumbers
          // rowNumberDisplayMode="static"
          // displayColumnDefOptions={{
          //   'mrt-row-numbers': {
          //     header: 'S No',
          //     size: 100,
          //     muiTableHeadCellProps: { align: 'center' },
          //     muiTableBodyCellProps: { align: 'center' },
          //   },
          // }}
          muiTableHeadCellProps={{
            sx: {
              fontWeight: 500,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#F8F8F8",
              border: "1px solid #D8D8D8",
            },
          }}
          muiTableBodyRowProps={{
            sx: {
              fontWeight: 400,
              fontSize: "14px",
              color: "#505258",
              padding: "10px 14px",
              backgroundColor: "#FFFFFF",
              border: "1px solid #D8D8D8",
              opacity: "0.54"
            },
          }}
          enableExpanding={false}
          enableRowSelection={false}
          enableFullScreenToggle={false}
          enableColumnActions={false}
        />
      )}
    </Box>
  );
}